module.exports = __webpack_public_path__ + "img/mobile.94041bf9.jpg";